import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/DEC_campus_DWTC.webp';

const Project_seven = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>DEC Campus Legacy — Expo City Dubai</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>The Dubai Exhibition Centre Campus Legacy project at Expo City Dubai, transforming the former Expo 2020 venue into a
                permanent world-class exhibition and business district. One of the UAE's largest post-event urban repurposing developments.</p>
              <p>MAIN CONTRACTOR : Khansaheb</p>
              <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
              <p>GEMCO SCOPE OF WORKS : Electrical busbar installations</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>


  )
}

export default Project_seven